import React from "react";
import SubList from "./_support/SubList";
import TableInput from "../forms/formElements/TableInput";
import SelectInput from "../forms/formElements/SelectInput";
import DateInput from "../forms/formElements/DateInput";
import TableInputRow from "../forms/formElements/TableInputRow";
import ComboWithOptions from "../forms/tableLists/ComboWithOptions";

const headers = ["Vlastník", "Umiestnenie Inštalácie", "Dátum"]

function InstrumentHistory(props) {
    return (
        <SubList label="História">
            <TableInput headers={headers} delete={props.delete}>
                {props.data['Historia'].map((item, index) => (
                    <TableInputRow delete={props.delete} ndx={index} index={0}>
                        <ComboWithOptions options={props.getOwnerOptions()}
                                          optionDisplay={'Vlastnik'}
                                          select={props.updateOwner}
                                          value={item.Vlastnik}
                                          ndx={index}
                                          index=''
                                          name={props.mainColumnName}
                                          reset={props.resetOwner}
                        />
                        <SelectInput options={props.getLocationOptions(index)}
                                     name={'Umiestnenie_Instalacie'}
                                     value={props.get_place(index)}
                                     onChange={event => props.updateLocation(event, index)}/>
                        <DateInput name={'Datum'} value={item.Datum}
                                   onChange={(event) => props.updateDate(event, index)}/>
                    </TableInputRow>
                ))
                }
                <tr>
                    <ComboWithOptions options={props.getOwnerOptions()}
                                      optionDisplay={'Vlastnik'}
                                      select={props.selectOwner}
                                      value=''
                                      ndx=''
                                      index=''
                                      name={props.mainColumnName}
                                      stateResetOnChange={true}
                    />
                </tr>
            </TableInput>
        </SubList>
    )
}

export default InstrumentHistory
